import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import css from './RacingThemeListingBreadcrumbs.module.css';

/**
 * Listing detail breadcrumbs.
 */
const RacingThemeListingBreadcrumbs = props => {
  const { items, className } = props;

  if (!items?.length) {
    return null;
  }

  return (
    <nav className={classNames(css.root, className)} aria-label="Breadcrumb">
      <ol className={css.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className={css.item}>
              {index > 0 ? <span className={css.sep} aria-hidden="true">/</span> : null}
              {isLast || !item.href ? (
                <span className={css.current} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              ) : (
                <Link className={css.link} to={item.href}>
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

RacingThemeListingBreadcrumbs.defaultProps = {
  className: null,
  items: [],
};

RacingThemeListingBreadcrumbs.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

export default RacingThemeListingBreadcrumbs;
